<div class="loader-container">
    <mat-spinner mode="indeterminate"></mat-spinner>
</div>